import React from "react";

export default function NotesInformation({ notes, lines = 6.5 }) {
  return (
    <>
      <pre
        className="rounded border w-full overflow-y-auto overflow-x-hidden whitespace-pre-wrap break-all border-gray-400 bg-gray-100 px-2 py-1 text-xs font-normal leading-4 text-gray-800"
        style={{ maxHeight: `calc(1rem * ${lines} + 0.5rem)` }}
      >
        {notes || "--"}
      </pre>
    </>
  );
}
